/* Wikholm – Återförsäljarkarta (Leaflet + OpenStreetMap). */
(function () {
  'use strict';

  const SWEDEN_CENTER = [62.0, 15.5];
  const SWEDEN_ZOOM = 5;

  function ready(fn) {
    if (window.L && L.markerClusterGroup) return fn();
    window.addEventListener('load', fn, { once: true });
  }

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const normZip = (s) => String(s || '').replace(/\D/g, '');
  const fmtZip = (z) => (z.length === 5 ? z.slice(0, 3) + ' ' + z.slice(3) : z);
  const toNum = (v) => (v === null || v === undefined || v === '' ? NaN : Number(String(v).replace(',', '.')));

  function km(a, b) {
    const R = 6371, rad = Math.PI / 180;
    const dLat = (b[0] - a[0]) * rad, dLng = (b[1] - a[1]) * rad;
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(a[0] * rad) * Math.cos(b[0] * rad) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  const fmtKm = (d) => (d < 10 ? d.toFixed(1).replace('.', ',') : Math.round(d)) + ' km';

   async function loadResellers(url) {
    const all = [];
    let page = 1, pages = 1;
    do {
      const sep = url.includes('?') ? '&' : '?';
      const t = window.Shopify && Shopify.theme;
      const preview = t && t.id && t.role !== 'main' ? '&preview_theme_id=' + t.id : '';
      const res = await fetch(url + sep + 'page=' + page + preview, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Kunde inte hämta återförsäljare (' + res.status + ')');
      const text = (await res.text()).trim();
      let json;
      try { json = JSON.parse(text); } catch (e) { throw new Error('Datamallen svarade inte med JSON: ' + text.slice(0, 300)); }
      all.push(...(json.items || []));
      pages = json.pages || 1;
      page++;
    } while (page <= pages && page <= 40);
    return all;
  }

  async function loadPostcodes(url) {
    try {
      const res = await fetch(url);
      if (!res.ok) return null;
      const table = await res.json();
      const sums = {};
      for (const [z, c] of Object.entries(table)) {
        for (const len of [3, 2]) {
          const p = z.slice(0, len);
          const s = (sums[p] = sums[p] || [0, 0, 0]);
          s[0] += c[0]; s[1] += c[1]; s[2]++;
        }
      }
      const prefix = {};
      for (const [p, s] of Object.entries(sums)) prefix[p] = [s[0] / s[2], s[1] / s[2]];
      return { table, prefix };
    } catch (e) {
      console.warn('[Återförsäljare] Postnummertabell saknas eller är ogiltig.', e);
      return null;
    }
  }

  function zipToCoord(pc, zip) {
    if (!pc || zip.length < 3) return null;
    if (zip.length === 5 && pc.table[zip]) return { c: pc.table[zip], exact: true };
    const p3 = pc.prefix[zip.slice(0, 3)];
    if (p3) return { c: p3, exact: false };
    const p2 = pc.prefix[zip.slice(0, 2)];
    return p2 ? { c: p2, exact: false } : null;
  }

  async function geocode(q) {
    const zip = normZip(q);
    const params = new URLSearchParams({ format: 'json', limit: '1', countrycodes: 'se' });
    if (/^\d{3}\s?\d{2}$/.test(q.trim())) params.set('postalcode', zip); else params.set('q', q);
    const res = await fetch('https://nominatim.openstreetmap.org/search?' + params, { headers: { 'Accept-Language': 'sv' } });
    if (!res.ok) return null;
    const r = (await res.json())[0];
    return r ? { c: [Number(r.lat), Number(r.lon)], label: r.display_name.split(',').slice(0, 2).join(',') } : null;
  }

  function cardHtml(r, i, dist) {
    const addr = [esc(r.street), [fmtZip(normZip(r.zip)), esc(r.city)].filter(Boolean).join(' ')].filter(Boolean).join('<br>');
    const web = r.web ? (/^https?:\/\//i.test(r.web) ? r.web : 'https://' + r.web) : '';
    const links = [
      r.phone && `<a href="tel:${esc(String(r.phone).replace(/[^\d+]/g, ''))}">${esc(r.phone)}</a>`,
      r.email && `<a href="mailto:${esc(r.email)}">${esc(r.email)}</a>`,
      web && `<a href="${esc(web)}" target="_blank" rel="noopener">${esc(r.web.replace(/^https?:\/\//i, '').replace(/\/$/, ''))}</a>`,
      `<a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([r.street, r.zip, r.city, 'Sverige'].filter(Boolean).join(', '))}" target="_blank" rel="noopener">Vägbeskrivning</a>`
    ].filter(Boolean).join('');
    return { addr, links, html:
      `<span class="af__num">${i + 1}</span><p class="af__name">${esc(r.name)}</p>` +
      `<span class="af__dist">${dist != null ? fmtKm(dist) : ''}</span>` +
      `<p class="af__addr">${addr}</p><div class="af__links">${links}</div>` };
  }

  function init(root) {
    const $ = (s) => root.querySelector(s);
    const status = $('[data-af-status]'), list = $('[data-af-list]'), input = $('[data-af-input]');
    const count = parseInt(root.dataset.count, 10) || 5;
    const useGeocoder = root.dataset.useGeocoder !== 'false';
    const setStatus = (t) => { status.textContent = t; };

    const map = L.map($('[data-af-map]'), { scrollWheelZoom: false }).setView(SWEDEN_CENTER, SWEDEN_ZOOM);
       L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);
    map.on('focus', () => map.scrollWheelZoom.enable());
    map.on('blur', () => map.scrollWheelZoom.disable());

    const cluster = L.markerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 50 });
    const nearestLayer = L.layerGroup();
    map.addLayer(cluster);
    map.addLayer(nearestLayer);
    let youMarker = null, resellers = [], postcodes = null;

    const dimIcon = L.divIcon({ className: '', html: '<div class="af-pin af-pin--dim"></div>', iconSize: [16, 16], iconAnchor: [8, 16], popupAnchor: [0, -14] });
    const numIcon = (n) => L.divIcon({ className: '', html: `<div class="af-pin"><span>${n}</span></div>`, iconSize: [26, 26], iconAnchor: [13, 26], popupAnchor: [0, -24] });
    const popupHtml = (r) => { const c = cardHtml(r, 0); return `<strong>${esc(r.name)}</strong><br>${c.addr}<div class="af__links">${c.links}</div>`; };

    function showNearest(origin, label) {
      const ranked = resellers.map((r) => ({ r, d: km(origin, r.coord) })).sort((a, b) => a.d - b.d).slice(0, count);
      list.innerHTML = '';
      nearestLayer.clearLayers();
      cluster.clearLayers();
      const shown = new Set(ranked.map((x) => x.r));
      cluster.addLayers(resellers.filter((r) => !shown.has(r)).map((r) => r.marker));

      if (youMarker) map.removeLayer(youMarker);
      youMarker = L.marker(origin, { icon: L.divIcon({ className: '', html: '<div class="af-you"></div>', iconSize: [16, 16] }), interactive: false, zIndexOffset: 1000 }).addTo(map);

      ranked.forEach(({ r, d }, i) => {
        const m = L.marker(r.coord, { icon: numIcon(i + 1), zIndexOffset: 500 - i }).bindPopup(popupHtml(r));
        nearestLayer.addLayer(m);
        const li = document.createElement('li');
        li.className = 'af__item';
        li.innerHTML = cardHtml(r, i, d).html;
        li.addEventListener('click', (e) => {
          if (e.target.closest('a')) return;
          list.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));
          li.classList.add('is-active');
          map.setView(r.coord, Math.max(map.getZoom(), 13));
          m.openPopup();
        });
        list.appendChild(li);
      });
      map.fitBounds(L.latLngBounds([origin, ...ranked.map((x) => x.r.coord)]).pad(0.15), { maxZoom: 13 });
      setStatus(`${ranked.length} närmaste återförsäljare till ${label}`);
    }

    async function search(q) {
      q = q.trim();
      if (!q) return;
      setStatus('Söker…');
      const zip = normZip(q);
      let hit = null, label = q;
      if (/^\d[\d\s]*$/.test(q)) {
        const z = zipToCoord(postcodes, zip);
        if (z) { hit = z.c; label = fmtZip(zip); }
      }
      if (!hit && useGeocoder) {
        try { const g = await geocode(q); if (g) { hit = g.c; label = g.label; } } catch (e) { console.warn(e); }
      }
      if (!hit) return setStatus(`Hittade inte "${q}". Kontrollera postnumret och försök igen.`);
      try { const u = new URL(location.href); u.searchParams.set('q', q); history.replaceState(null, '', u); } catch (e) {}
      showNearest(hit, label);
    }

    $('[data-af-form]').addEventListener('submit', (e) => { e.preventDefault(); search(input.value); });
    $('[data-af-locate]').addEventListener('click', () => {
      if (!navigator.geolocation) return setStatus('Din webbläsare kan inte dela position.');
      setStatus('Hämtar din position…');
      navigator.geolocation.getCurrentPosition(
        (p) => showNearest([p.coords.latitude, p.coords.longitude], 'din position'),
        () => setStatus('Kunde inte hämta din position. Sök på postnummer i stället.'),
        { timeout: 10000, maximumAge: 600000 }
      );
    });

    Promise.all([loadResellers(root.dataset.dataUrl), loadPostcodes(root.dataset.postcodeUrl)])
      .then(([raw, pc]) => {
        postcodes = pc;
        const missing = [];
        resellers = raw.map((r) => {
          let lat = toNum(r.lat), lng = toNum(r.lng);
          if (!(isFinite(lat) && isFinite(lng))) {
            const z = zipToCoord(pc, normZip(r.zip));
            if (z) { lat = z.c[0]; lng = z.c[1]; }
          }
          if (!(isFinite(lat) && isFinite(lng))) { missing.push(r.name || r.id); return null; }
          r.coord = [lat, lng];
          r.marker = L.marker(r.coord, { icon: dimIcon }).bindPopup(popupHtml(r));
          return r;
        }).filter(Boolean);
        if (missing.length) console.warn('[Återförsäljare] Saknar position (' + missing.length + '):', missing);
        cluster.addLayers(resellers.map((r) => r.marker));
           setStatus(resellers.length ? `Sök för att se de ${count} närmaste.` : 'Inga återförsäljare hittades.');
        const q = new URLSearchParams(location.search).get('q');
        if (q) { input.value = q; search(q); }
      })
      .catch((e) => { console.error(e); setStatus('Kunde inte ladda återförsäljarna just nu.'); });
  }

  ready(() => document.querySelectorAll('[data-af-locator]').forEach(init));
})();